import React, { useState, useRef, useEffect } from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import '../styles/RollingShowcase.css';

const RollingShowcase = ({ speed = 50, images }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const trackRef = useRef(null);

  const handleMouseDown = (e) => {
    if (isMobile && trackRef.current) {
      setIsDragging(true);
      setStartX(e.pageX - trackRef.current.offsetLeft);
      setScrollLeft(trackRef.current.scrollLeft);
      trackRef.current.style.cursor = 'grabbing';
    }
  };


  const handleMouseUp = () => {
    if (isMobile && trackRef.current) {
      setIsDragging(false);
      trackRef.current.style.cursor = 'grab'; // Ensure it goes back to grab
    }
  };

  const handleTouchStart = (e) => { // Corrected: Added '=>'
    if (isMobile && trackRef.current) {
      setIsDragging(true);
      // Use e.touches[0].pageX for touch events
      setStartX(e.touches[0].pageX - trackRef.current.offsetLeft);
      setScrollLeft(trackRef.current.scrollLeft);
    }
  };

  const handleTouchMove = (e) => { // Corrected: Added '=>'
    if (!isDragging || !isMobile || !trackRef.current) return;
    e.preventDefault(); // Prevent default for touch move to prevent page scrolling
    const x = e.touches[0].pageX - trackRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // Consistent multiplier
    trackRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchEnd = () => {
    if (isMobile) {
      setIsDragging(false);
    }
  };

  // Set cursor style based on dragging state and device
  useEffect(() => {
    if (trackRef.current) {
      if (isMobile) {
        trackRef.current.style.cursor = isDragging ? 'grabbing' : 'grab';
      } else {
        trackRef.current.style.cursor = 'auto'; // Desktop default
      }
    }
  }, [isDragging, isMobile]);

  return (
    <div className={`rolling-showcase-container ${isMobile ? 'mobile-view' : ''}`}>
      {isMobile && <div className="swipe-hint">Swipe to browse</div>}
      <div
        ref={trackRef}
        className={`rolling-showcase-track ${!isMobile ? 'animated-track' : ''}`}
        style={isMobile ? {} : { '--speed': `${speed}s` }}
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseUp} // Treat mouse leaving as mouse up
        onMouseUp={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {images.map((imageSrc, index) => (
          <img
            key={`original-${index}`}
            src={imageSrc}
            alt={`Showcase item ${index + 1}`}
            className="showcase-image"
          />
        ))}
        {!isMobile && images.map((imageSrc, index) => (
          <img
            key={`duplicate-${index}`}
            src={imageSrc}
            alt={`Showcase item duplicate ${index + 1}`}
            className="showcase-image"
          />
        ))}
      </div>
    </div>
  );
};

export default RollingShowcase;
